import historyTabTemplate from '@/audit/layout/historyTabTemplate';

export default historyTabTemplate(['roles'], ({ roles }) => roles.audit, 'role');
